/* eslint-disable */
var $ = window.jQuery = require('jquery');

import draggable from "vuedraggable";
import { mapGetters } from 'vuex';
import toast from '@/services/toast';

export default {
  name: 'interview-quiz-list',
  components: {
    draggable
  },
  props: [],
  data() {
    return {
      quizListDetails:null,
      removeQuizId:'',
      addquiz: null,
      isActive: false,
      is_active: false,
      pub_catID:'',
      isVisible: false,
      is_visible: false,
    }
  },
  computed: {
    dragOptions() {
      return {
        animation: 0,
        group: "description",
        ghostClass: "ghost"
      };
    },
  },
  mounted() {
    this.getContestListMethod()
  },
  methods: {
    getContestListMethod(){
      this.$store.dispatch('getInterviewQuizListAction').then((res) => {
        this.quizListDetails = res.data.data
      })
    },
    courseQuizStatusAct(quizId) {
      let data = {
        id: quizId
      }
      this.$store.dispatch('getQuizDetailsByIdFun', data)
        .then((res) => {
          if (res.data.code == '2000') {
            this.isActive = this.$store.getters.getQuizDetailsByIdDataState.is_active
            if (this.isActive === true) {
              this.is_active = false
            }
            if (this.isActive === false) {
              this.is_active = true
            }
            let data = {
              is_active: this.is_active,
            }
            this.$store.dispatch('updateQuizFun', {
              data: {
                data: data,
                id: quizId
              }
            }).then((res) => {
              if (res.status == '200') {
                this.geQuizListAgain();
                toast.success("Quiz Status Updated Successfully");
              }
            }).catch((err) => {})
            return
          }
        }).catch((err) => {})
    },
    courseIsvisibleStatusAct(quizId) {
      let data = {
        id: quizId
      }
      this.$store.dispatch('getQuizDetailsByIdFun', data)
        .then((res) => {
          if (res.data.code == '2000') {
            this.isVisible = this.$store.getters.getQuizDetailsByIdDataState.is_visible
            if (this.isVisible === true) {
              this.is_visible = false
            }
            if (this.isVisible === false) {
              this.is_visible = true
            }
            let data = {
              is_visible: this.is_visible,
            }
            this.$store.dispatch('updateQuizFun', {
              data: {
                data: data,
                id: quizId
              }
            }).then((res) => {
              if (res.status == '200') {
                this.geQuizListAgain();
                toast.success("Quiz Status Updated Successfully");
              }
            }).catch((err) => {})
            return
          }
        }).catch((err) => {})
    },
    removeQuizagain(id) {
      $('#removQuizModalAgain').modal();
      this.removeQuizId = id
    },
    RemoveQuizConfirmationagain(){
      this.$store.dispatch('deleteInterviewInfoByIdAction', {
        id: this.removeQuizId
      }).then((res) => {
        this.getContestListMethod()
      }).catch((err) => {})
    }
  },
  beforeMount() {
  },
  watch: {
  }
}